import React from "react";
import { Port } from "./Types";
import { PortUsageCard } from "./PortUsageCard";

interface PortUsageListProps {
  ports: Port[];
  onCardClick?: (port: Port) => void;
}

export function PortUsageList({ ports, onCardClick }: PortUsageListProps) {
  return (
    <div className="flex space-x-5">
      {ports.map((port) => (
        <div key={port.id} className="min-w-[300px] flex-shrink-0">
          <PortUsageCard key={port.id} port={port} onClick={onCardClick}/>
        </div>
      ))}
    </div>
  );
}
